(function () {
    "use strict";

    /*This controller is used in history pop for adding notes to history*/
    var LogActionCtrl = function (
      $scope,
      $http,
      $httpParamSerializerJQLike,
      xmsNotificationFactory,
      $uibModalInstance
    ) {
      var __DEFAULT = "5154";
      var __FALSE = "false";

      //default values to hide the inputs
      $scope.showCandidate = __DEFAULT;
      $scope.showBusiness = __DEFAULT;
      $scope.showManager = __DEFAULT;
      $scope.showItem = __DEFAULT;
      $scope.showSubTypes = __FALSE;
      $scope.showActionSubTypes = __DEFAULT;
      $scope.showHistoryVisibilityLookupValId = __DEFAULT;

      $scope.showSuccessMsg = false;
      $scope.disableButtons = false;

      /*On change event for label changes*/
      var saveAndClose = false;

      $scope.saveAndClose = function () {
        saveAndClose = true;
      };

      const visited = [];
      let firstOpened = true;
      $scope.changeLabel = function () {
        var labelId = $scope.formModel.actionLogLabelTypeId;
        var xmsTypeLookupValId = angular.isDefined(
          $scope.formModel.xmsTypeIdFromLookup
        )
          ? $scope.formModel.xmsTypeIdFromLookup
          : "";
        $scope.formModel.actionLogLabelSubTypeId = "";
        var url = "/actionLog/labelValues";
        $http
          .get(
            WEBAPP_PATH +
              url +
              "?labelId=" +
              labelId +
              "&xmsTypeLookupValId=" +
              xmsTypeLookupValId
          )
          .then(function (response) {
            $scope.showItem = response.data.item;
            $scope.showCandidate = response.data.candidate;
            $scope.showBusiness = response.data.business;
            $scope.showManager = response.data.manager;
            $scope.showSubTypes = response.data.showSubTypes;
            $scope.formModel.historyVisibilityLookupValId =
              response.data.historyVisibilityLookupValId;
            if ($scope.showSubTypes) {
              $scope.showCandidate = __DEFAULT;
              $scope.showBusiness = __DEFAULT;
              $scope.showManager = __DEFAULT;
              $scope.showItem = __DEFAULT;
            }
            $scope.showActionSubTypes = response.data.subTypeActions;

            if (!firstOpened) {
              if (visited[labelId]) {
                $scope.formModel.actionLogLabelSubTypeId = {};
                $scope.formModel.actionLogLabelSubTypeId.id = visited[labelId];
                $scope.changeSubType();
              } else {
                $scope.formModel.actionLogLabelSubTypeId = undefined;
              }
            } else {
              $scope.formModel.actionLogLabelSubTypeId = response.data.preFilledActionSubType;
              $scope.changeSubType();
              firstOpened = false;
            }
            if($scope.showActionSubTypes === undefined || $scope.showActionSubTypes.length == 0){
              $scope.formModel.actionLogLabelSubTypeId = undefined
            }

          });
      };

      $scope.changeSubType = function () {
        const actionLogLabelSubTypeId =
          $scope.formModel.actionLogLabelSubTypeId.id;
        if (!actionLogLabelSubTypeId) return;
        var url = "/actionLog/labelSubValues";
        $http
          .get(WEBAPP_PATH + url + "?subTypeId=" + actionLogLabelSubTypeId)
          .then(function successCallBack(response) {
            $scope.showItem = response.data.item;
            $scope.showCandidate = response.data.candidate;
            $scope.showBusiness = response.data.business;
            $scope.showManager = response.data.manager;
            $scope.showHistoryVisibilityLookupValId =
              response.data.historyVisibilityLookupValId;
          });
        visited[$scope.formModel.actionLogLabelTypeId] =
          $scope.formModel.actionLogLabelSubTypeId.id;
      };

      $scope.cancelPop = function (e) {
        if (angular.isDefined(e)) {
          e.preventDefault();
        }
        if ($scope.formModel.requestFrom == "manager") {
          location.reload();
        }
        $scope.cancel();
      };

      $scope.postForm = function ($event) {
        $event.preventDefault();

        var urlPost = "/actionLog/actionLogManualInsert?";
        console.log("inside post");
        /*Assigning the populated hidden field values*/
        //formModel is used for Add Note To History Stuff
        //ngModel is used for the Add Alert within the AddNoteToHistory pop
        var data = {
          xmsId: angular.isDefined($scope.formModel.xmsId)
            ? $scope.formModel.xmsId
            : "",
          xmsTypeLookupValId: angular.isDefined(
            $scope.formModel.xmsTypeIdFromLookup
          )
            ? $scope.formModel.xmsTypeIdFromLookup
            : "",
          candidateId: angular.isDefined($scope.formModel.candidateId)
            ? $scope.formModel.candidateId
            : "",
          managerId: angular.isDefined($scope.formModel.managerId)
            ? $scope.formModel.managerId
            : "",
          // historyVisibilityLookupValId   : angular.isDefined($scope.formModel.historyVisibilityLookupValId)           ? $scope.formModel.historyVisibilityLookupValId           : '',
          managerRoleId: angular.isDefined($scope.formModel.managerRoleId)
            ? $scope.formModel.managerRoleId
            : "",
          businessId: angular.isDefined($scope.formModel.businessIdFromPop)
            ? $scope.formModel.businessIdFromPop
            : "",
          itemId: angular.isDefined($scope.formModel.itemId)
            ? $scope.formModel.itemId
            : "",
          actionLogLabel: $scope.formModel.actionLogLabelTypeId,
          actionLogLabelSubTypeId: $scope.formModel.actionLogLabelSubTypeId ? $scope.formModel.actionLogLabelSubTypeId.id : "",
          commentDetails: $scope.formModel.sysOrManOrCommsTracComments,
          historyVisibilityLookupValId:
            $scope.formModel.historyVisibilityLookupValId,
          addTimeBasedAlert: angular.isDefined($scope.formModel.addTimeBasedAlert)
            ? $scope.formModel.addTimeBasedAlert
            : "",
          categoryId: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.categoryId)
            ? $scope.ngModel.categoryId
            : "",
          assignee: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.assignee)
            ? $scope.ngModel.assignee
            : "",
          title: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.title)
            ? $scope.ngModel.title
            : "",
          message: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.message)
            ? $scope.ngModel.message
            : "",
          schedulerDropDown: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.schedulerDropDown)
            ? $scope.ngModel.schedulerDropDown
            : "",
          sendDate: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.sendDate)
            ? $scope.ngModel.sendDate
            : "",
          sendTime: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.sendTime)
            ? $scope.ngModel.sendTime
            : "",
          repeat: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.repeat)
            ? $scope.ngModel.repeat
            : "",
          repeatPeriod: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.repeatPeriod)
            ? $scope.ngModel.repeatPeriod
            : "",
          periodType: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.periodType)
            ? $scope.ngModel.periodType
            : "",
          hours: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.hours)
            ? $scope.ngModel.hours
            : "",
          minutes: angular.isDefined($scope.ngModel) && angular.isDefined($scope.ngModel.minutes)
            ? $scope.ngModel.minutes
            : "",
          inst: angular.isDefined($scope.formModel.inst)
            ? $scope.formModel.inst
            : "",
        };

        // disable the submit button on click
        $scope.disableButtons = true;

        $http
          .post(WEBAPP_PATH + urlPost, $httpParamSerializerJQLike(data))
          .then(function (response) {
            /* Show the status message  on the screen */
            $scope.showSuccessMsg = true;

            //If saveClose button is clicked, close the pop
            if (saveAndClose == true) {
              saveAndClose = false;
              xmsNotificationFactory.addObj({
                id: "addNoteToHistory",
                type: response.data.responseType,
                bodyHtml: response.data.message,
                timeout: 5,
              });
              if ($scope.formModel.requestFrom == "manager") {
                location.reload();
              }
              $scope.ok();
            }

            /* Reseting values */
            //    $scope.formModel.candidateName               = '';
            //    $scope.formModel.businessRecordName          = '';
            //    $scope.formModel.managerName                 = '';
            $scope.formModel.sysOrManOrCommsTracComments = "";
            //    $scope.formModel.itemTitle                   = '';
            //    $scope.formModel.actionLogLabelTypeId        = '';

            //    $scope.showCandidate = __DEFAULT;
            //    $scope.showBusiness  = __DEFAULT;
            //    $scope.showManager   = __DEFAULT;
            //    $scope.showItem      = __DEFAULT;

            //Enable the Submit Button after submit
            $scope.disableButtons = false;

            // reset form
            $scope.podForm.$setPristine();
            $scope.podForm.$setUntouched();
          });
      };
    };
    LogActionCtrl.$inject = [
      "$scope",
      "$http",
      "$httpParamSerializerJQLike",
      "xmsNotificationFactory",
    ];
    angular.module("app").controller("LogActionCtrl", LogActionCtrl);
  })();
